import api from '@/utils/api';

const controller = 'v1.0/produto';
const produtoExport = Object.assign(
    {},
    api.GetCrud(controller, ["none"]),
    {
        CadastroProduto: function (model) {
            return api.Axios.Post(controller, model);
        },
        AtualizarProduto: function (model) {
            return api.Axios.PutWithoutId(controller, model);
        },
        GetProdutoPorUsuario(config = {}) {
            return api.Axios.GetParams(controller + '/Usuario', config);
        },
        GetById: function (id) {
            return api.Axios.Get(controller + "/" + id);
        },
        GetTodos: function () {
            return api.Axios.Get(controller + "/Todos");
        },
        Delete: function (id) {
            return api.Axios.Delete(controller + "/" + id);
        },
    }
);

export default produtoExport;